import React from "react";
import { Navbar } from "react-bootstrap";
import Footer from "../../components/Footer";

const RefundPolicy = () => {
  return (
    <>
      <Navbar />
      <section className="privacy_sec">
        <div className="container">
          <div className="privacy_content">
            <h1>Refund Policy</h1>
            <h5>Eligibility</h5>
            <p>
              Refunds are only available for products or services that are defective or not as described. To be eligible for a refund, users must provide proof of the issue within the specified refund period.
            </p>

            <h5>Refund Process</h5>
            <p>
              Once a refund request is approved, the refund will be processed via the original method of payment within 5–7 working days. The credited amount will reflect in the customer’s bank account or payment source within this period, depending on the policies of the respective bank or payment gateway.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default RefundPolicy;
